import React from 'react';
import { Check, ShieldCheck } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function PricingCard() {
  const features = ['MegaPack Inclusivo Infantil completo (+500 recursos)', 'Bono #1: +98 Libros para Colorear', 'Bono #2: Mini Pack Atención y Concentración', 'Bono #3: Guía Express Control de Emociones', 'Acceso inmediato y de por vida', 'Actualizaciones futuras incluidas'];
  return <div className="max-w-2xl mx-auto bg-white rounded-2xl shadow-2xl overflow-hidden border-2 border-[#fbbf24] relative" data-id="element-24">
      <div className="bg-[#fbbf24] py-2 text-center font-bold text-black uppercase tracking-wider text-sm" data-id="element-25">
        Oferta por tiempo limitado
      </div>

      <div className="p-8 md:p-12 text-center" data-id="element-26">
        <h3 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-27">
          MegaPack Inclusivo Infantil
        </h3>
        <p className="text-gray-500 mb-8" data-id="element-28">Edición Completa + Todos los Bonos</p>

        <div className="flex flex-col items-center justify-center mb-8" data-id="element-29">
          <span className="text-gray-400 line-through text-2xl font-semibold" data-id="element-30">
            $49.99 USD
          </span>
          <div className="flex items-baseline gap-2" data-id="element-31">
            <span className="text-5xl md:text-6xl font-extrabold text-[#10b981]" data-id="element-32">
              $12.99
            </span>
            <span className="text-xl font-bold text-gray-600" data-id="element-33">USD</span>
          </div>
          <p className="text-[#10b981] font-semibold mt-2 bg-green-50 px-3 py-1 rounded-full text-sm" data-id="element-34">
            Ahorrás $37.00 USD HOY
          </p>
          <p className="text-gray-600 text-sm mt-3 font-medium" data-id="element-35">
            💳 Pagarás en la moneda de tu país
          </p>
        </div>

        <ul className="text-left space-y-4 mb-10 max-w-md mx-auto" data-id="element-36">
          {features.map((feature, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-37">
              <div className="bg-green-100 p-1 rounded-full mt-0.5 flex-shrink-0" data-id="element-38">
                <Check className="w-4 h-4 text-[#10b981]" data-id="element-39" />
              </div>
              <span className="text-gray-700 font-medium" data-id="element-40">{feature}</span>
            </li>)}
        </ul>

        <div className="space-y-4" data-id="element-41">
          <CTAButton href="https://checkout7.edulabs.online/cart/44571569750085:1" className="w-full text-xl md:text-2xl py-5 shadow-xl animate-pulse-slow" data-id="element-42">
            👉 OBTENER MI MEGAPACK INCLUSIVO HOY
          </CTAButton>

          <div className="flex flex-col md:flex-row items-center justify-center gap-4 text-sm text-gray-500 mt-4" data-id="element-43">
            
            <span className="flex items-center gap-1" data-id="element-44">
              <Check className="w-4 h-4" data-id="element-45" /> Acceso inmediato
            </span>
            <span className="flex items-center gap-1" data-id="element-46">
              <Check className="w-4 h-4" data-id="element-47" /> Un solo pago
            </span>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-gray-100 flex items-center justify-center gap-2 text-gray-500 text-sm" data-id="element-48">
          <ShieldCheck className="w-5 h-5 text-gray-400" data-id="element-49" />
          <span data-id="element-50">Garantía de satisfacción de 7 días</span>
        </div>
      </div>
    </div>;
}